import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const Avatar = styled.img`
  display: block;
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  transition: border-color 0.2s;
  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }
`

export const Popover = styled.div`
  position: fixed; /* ⬅️ importante */
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;

  width: 220px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.background};
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  z-index: 1000;

  animation: fadeIn 0.15s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`

export const ProfileInfo = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
`

export const InfoText = styled.div`
  margin-left: 12px;
`

export const Name = styled.div`
  font-weight: 600;
  font-size: 14px;
  /* color: #111; */
`

export const Email = styled.div`
  font-size: 12px;
  /* color: #555; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ActionList = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 8px 0; */
`

export const ActionItem = styled.button`
  background: none;
  border: none;
  text-align: left;
  padding: 10px 16px;
  cursor: pointer;
  /* font-size: 14px; */
  color: ${({ theme }) => theme.colors.textPrimary};
  transition: background 0.15s;
  &:hover {
    background: ${({ theme }) => theme.colors.borderDefault};
  }

`
